import { render } from "./NotificacaoTable.vue?vue&type=template&id=4f9a868e"
import script from "./NotificacaoTable.vue?vue&type=script&lang=js"
export * from "./NotificacaoTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__